<template>
  <div class="bg-white py-5 px-6 rounded-2xl">
    <div class="flex">
      <button
        class="rounded-full border px-6 py-1 font-bold focus:ring focus:border-primary focus:outline-none mr-8"
        :class="
          showCredit
            ? 'border-primary text-primary'
            : 'border-textPrimary  opacity-20'
        "
        @click="
        showDebit = false;
        showCredit = true;
        "
      >Credit</button>
      <button
        class="rounded-full border px-6 py-1 font-bold focus:ring focus:border-primary focus:outline-none"
        :class="
          showDebit
            ? 'border-primary text-primary'
            : 'border-textPrimary  opacity-20'
        "
        @click="
        showDebit = true;
        showCredit = false;
        "
      >Debit</button>
    </div>
    <div class="grid gap-4 mt-4">
      <template v-if="rewardsList?.length">
        <div class="flex justify-between bg-greyBackground p-3" v-for="(reward, index) in rewardsList" :key="index">
          <div class>
            <p class="font-semibold">{{ reward.description }}</p>
            <p class="text-xs">{{ $filters.formatDate(reward.date) }}</p>
          </div>
          <p class="font-semibold">{{ reward.points }}</p>
        </div>
        <Observer @intersect="intersected" />
      </template>
      <no-data-available
        v-else
        imageName="no-transactions.png"
        message="You don't have any reward points."
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import NoDataAvailable from '../components/NoDataAvailable.vue';
import Observer from '../components/Observer.vue';

export default {
  name: 'RewardStatement',
  data() {
    return {
      isLoading: undefined,
      rewardStatement: undefined,
      start: 0,
      count: 50,
      showCredit: true,
      showDebit: false,
    };
  },
  computed: {
    ...mapGetters(['uuid']),
    rewardsList() {
      return this.showCredit
        ? this.rewardStatement?.loyaltyCreditPointList
        : this.rewardStatement?.loyaltyDebitPointList;
    },
  },
  components: {
    NoDataAvailable,
    Observer
  },
  mounted() {
    this.init();
  },
  watch: {
    showCredit() {
      this.init();
    },
    showDebit() {
      this.init();
    },
  },
  methods: {
    init() {
      this.start = 0;
      this.getCustomerLoyaltyPoint();
    },
    intersected() {
      if (!this.isLoading && this.start) {
        if (
          (this.showDebit &&
            this.start <
            this.rewardStatement.totalAvailableDebitCount) ||
          (this.showCredit &&
            this.start <
            this.rewardStatement.totalAvailableCreditCount)
        ) {
          this.getCustomerLoyaltyPoint();
        }
      }
    },

    getCustomerLoyaltyPoint() {
      this.isLoading = true;
      this.$store
        .dispatch('customerLoyaltyPoint', {
          uuid: this.uuid,
          urlParams: {
            start: this.start,
            count: this.count,
          },
        })
        .then((response) => {
          if (this.start) {
            if (this.showCredit) {
              this.rewardStatement.loyaltyCreditPointList.push(...response.loyaltyCreditPointList);
              this.start += response.loyaltyCreditPointList.length;
            } else {
              this.rewardStatement.loyaltyDebitPointList.push(...response.loyaltyDebitPointList);
              this.start += response.loyaltyDebitPointList.length;
            }
          } else {
            this.rewardStatement = response;
            if (this.showCredit) {
              this.start += response.loyaltyCreditPointList.length;
            }
            if (this.showDebit) {
              this.start += response.loyaltyDebitPointList.length;
            }
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.bg-referral-banner {
  background-image: url("../assets/rewards-illustration.png");
  @media only screen and (max-width: 640px) {
    background-image: url("../assets/rewards-illustration-mobile.png");
  }
}
</style>
